import { Component, Input } from '@angular/core';

/** Legacy `agm-marker` host — map marker is drawn by {@link AgmMap}; inputs kept for template compatibility. */
@Component({
  selector: 'agm-marker',
  template: '',
  styles: [':host { display: none; }']
})
export class AgmMarker {
  @Input() latitude: number | null = null;
  @Input() longitude: number | null = null;
}
